/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teams_Connect_No_AccountInputs */



/**
* | output |
* | --- |
* | "No oneAI account found for this Microsoft account. Please ask your administrator." |
*
* @param {Teams_Connect_No_AccountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teams_connect_no_account = /** @type {((inputs?: Teams_Connect_No_AccountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_Connect_No_AccountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kein oneAI-Konto für dieses Microsoft-Konto gefunden. Bitte wenden Sie sich an Ihren Administrator.")
	return /** @type {LocalizedString} */ ("No oneAI account found for this Microsoft account. Please ask your administrator.")
});